import { render, staticRenderFns } from "./T1TopRegionyTabs.vue?vue&type=template&id=dce67808&scoped=true&"
import script from "./T1TopRegionyTabs.vue?vue&type=script&lang=js&"
export * from "./T1TopRegionyTabs.vue?vue&type=script&lang=js&"
import style0 from "./T1TopRegionyTabs.vue?vue&type=style&index=0&id=dce67808&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dce67808",
  null
  
)

export default component.exports